<template>
  <div class="row border-bottom" v-if="possibleItems.list.tower">
    <div
      class="col-10 text-start menu-section"
      @click="toggleCurrentEdit('tower')"
    >
      <h5>{{ $t("Menu.list.stones.group.formSetting.tower.title") }}</h5>
      <p v-if="currentEdit != 'tower'">
        <template v-if="possibleItems.list.tower">
          <template v-for="(alloyItem, index) in possibleItems.list.tower">
            <span v-bind:key="'alloyItem-' + index" v-if="alloyItem.match">
              {{ alloyItem.text }}
            </span>
          </template>
        </template>
      </p>
    </div>
    <div class="col-2 text-end">
      <img
        :src="appUrl + '/img/icons/edit.svg'"
        class="icon open"
        @click="toggleCurrentEdit('tower')"
        v-if="currentEdit != 'tower'"
      />
      <img
        :src="appUrl + '/img/icons/close.svg'"
        class="icon"
        @click="toggleCurrentEdit('tower')"
        v-else
      />
    </div>
    <template v-if="currentEdit == 'tower'">
      <div class="col-12 text-center">
        <ul class="default-option-list">
          <template v-for="(item, index) in possibleItems.list.tower">
            <li v-if="item.match" v-bind:key="index" class="pointer match">
              <img
                :src="
                  appUrl +
                  '/img/assets/colors/a' +
                  '_' +
                  item.alloy_id.substr(0, 1).toLowerCase() +
                  '.jpg'
                "
                :srcset="
                  appUrl +
                  '/img/assets/colors/a' +
                  '_' +
                  item.alloy_id.substr(0, 1).toLowerCase() +
                  '@2x.jpg'
                "
                :alt="item.text"
                class="thumb"
              />
              <p>{{ item.text }}</p>
            </li>
          </template>
          <template v-for="(item, index) in towerList">
            <li
              v-if="!item.match"
              v-bind:key="'setting-' + index"
              @click="
                changeItemByVarValue(
                  'tower_' +
                    possibleItems.groupId +
                    '_' +
                    possibleItems.stoneId +
                    '_' +
                    item.alloy_id
                )
              "
              class="pointer"
            >
              <img
                :src="
                  appUrl +
                  '/img/assets/colors/a' +
                  '_' +
                  item.alloy_id.substr(0, 1).toLowerCase() +
                  '.jpg'
                "
                :srcset="
                  appUrl +
                  '/img/assets/colors/a' +
                  '_' +
                  item.alloy_id.substr(0, 1).toLowerCase() +
                  '@2x.jpg'
                "
                :alt="item.text"
                class="thumb"
              />
              <p>{{ item.text }}</p>
            </li>
          </template>
          <li
            v-if="
              form.show != 'tower' &&
              possibleItems.list.tower.length > form.maxItems
            "
            @click="form.show = 'tower'"
          >
            <img :src="appUrl + '/img/icons/next.svg'" class="ring" />
            {{ $t("Menu.list.stones.group.formSetting.add") }} &gt;
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "Form",
  props: ["possibleItems", "currentEdit", "itemData", "stoneId", "groupId"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      form: {
        show: "tower",
        maxItems: 99,
      },
    };
  },
  computed: {
    towerList: function () {
      let list = [];

      if (typeof this.possibleItems.list.tower == "object") {
        for (let key in this.possibleItems.list.tower) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list.tower,
              key
            )
          ) {
            if (
              (list.length < this.form.maxItems ||
                this.form.show === "tower") &&
              this.possibleItems.list.tower[key].match == false
            ) {
              list.push(this.possibleItems.list.tower[key]);
            }
          }
        }
      }

      return list;
    },
  },
  methods: {
    toggleCurrentEdit: function (id) {
      this.$parent.toggleCurrentEdit(id);
    },
    changeItemByVarValue: function (varValue) {
      this.$parent.changeItemByVarValue(varValue);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .menu-section {
    cursor: pointer;
  }

  label {
    font-weight: normal;
    line-height: 2.2em;
  }

  .text-bold {
    font-weight: bold;
  }

  img.ring {
    display: block;
    width: 5em;
    height: 5em;
    border-radius: 5em;
    border: solid 0.1rem $brandDarkGrey;
    margin: auto;
    margin-bottom: 0.5em;
  }

  .input-group input,
  .input-group select {
    height: 2.5em;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: center;
    display: inline-block;

    li {
      list-style: none;
      padding: 0;
      margin: 0.75em;
      text-align: center;
      display: inline-block;
      width: 6em;
      vertical-align: top;
      cursor: pointer;
    }

    li.match {
      position: relative;

      img.thumb {
        border: solid 0.2rem $brandGold;
      }

      .close {
        position: absolute;
        top: -0.5em;
        right: 0;
        font-size: 2em;
      }
    }
  }
}
</style>
